import { getData, patchData } from '~/utils/service';
import { NotificationInputArgs } from './types';

const NOTIFICATION_ROUTE_NAME = 'notifications';

export const NOTIFICATION_ROUTES = {
  get: '/notifications',
  patch: '/notifications/read',
};

// Own route table: handleServiceCall resolves ROUTES[name][method], so a second
// PATCH path needs its own name.
export const NOTIFICATION_READ_ALL_ROUTES = {
  patch: '/notifications/read-all',
};

export const NOTIFICATION_API_ROUTES = {
  get: async ({ input }: NotificationInputArgs): Promise<Notification[]> => {
    return await getData(NOTIFICATION_ROUTE_NAME);
  },
  patch: async ({ input }: NotificationInputArgs): Promise<Notification[]> => {
    return await patchData(NOTIFICATION_ROUTE_NAME, {
      data: {
        notificationIds: input.context.inFlightReadIds,
      },
    });
  },
  readAll: async (): Promise<{ count: number }> => {
    return await patchData('notificationsReadAll');
  },
};
